import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex snap-x snap-mandatory overflow-x-hidden scroll-smooth laptop:scroll-auto" }
const _hoisted_2 = { class: "sticky top-0 z-30 bg-white py-16" }
const _hoisted_3 = { class: "relative flex items-center justify-between" }
const _hoisted_4 = { class: "flex items-center gap-x-16" }
const _hoisted_5 = { class: "center-center absolute whitespace-nowrap text-22 font-medium" }
const _hoisted_6 = {
  ref: "closeBtn",
  type: "button",
  class: "modal-popup__close"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "relative h-128 w-full overflow-hidden" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "absolute inset-0 z-10 flex items-center justify-center bg-black-500 bg-opacity-60" }
const _hoisted_11 = { class: "flex flex-col items-center" }
const _hoisted_12 = { class: "mt-6 text-[0.5625rem] font-bold text-black-900" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "relative h-128 w-full overflow-hidden border border-transparent group-hover:border-black-500" }
const _hoisted_15 = {
  key: 1,
  class: "absolute bottom-0 w-full bg-black-50 py-2 text-white"
}
const _hoisted_16 = { class: "flex flex-col items-center" }
const _hoisted_17 = { class: "block text-12 text-black-900" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "text-[0.625rem]" }
const _hoisted_20 = {
  key: 2,
  class: "mt-20 block text-center text-20 font-medium"
}
const _hoisted_21 = {
  key: 0,
  ref: "quickView",
  class: "sticky top-0 z-40 min-w-full max-w-375 snap-center overflow-y-scroll bg-white px-16 pb-16"
}
const _hoisted_22 = { class: "sticky top-0 z-10 flex items-center justify-between bg-white py-16" }
const _hoisted_23 = { class: "center-center absolute whitespace-nowrap text-22 font-medium" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")
  const _component_product_picker_search = _resolveComponent("product-picker-search")
  const _component_product_picker_filter = _resolveComponent("product-picker-filter")
  const _component_product_picker_quick_filter = _resolveComponent("product-picker-quick-filter")
  const _component_grid_item_skeleton = _resolveComponent("grid-item-skeleton")
  const _component_v_image = _resolveComponent("v-image")
  const _component_grid_item_tags = _resolveComponent("grid-item-tags")
  const _component_product_picker_quick_view = _resolveComponent("product-picker-quick-view")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "picker",
      class: _normalizeClass(["min-w-full max-w-375 snap-center overflow-y-scroll px-16 pb-16", {'!overflow-y-hidden': $data.lockScroll}])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = (...args) => ($options.toggleSearch && $options.toggleSearch(...args)))
            }, [
              _createVNode(_component_v_icon, {
                icon: "search",
                width: 21,
                height: 21
              })
            ]),
            ($props.filters.length)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = (...args) => ($options.toggleFilter && $options.toggleFilter(...args)))
                }, [
                  _createVNode(_component_v_icon, {
                    icon: "filter",
                    width: 22,
                    height: 22
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_5, _toDisplayString($data.locale.select_design) + " " + _toDisplayString($data.productsIndex + 1), 1),
          _createElementVNode("button", _hoisted_6, [
            _createVNode(_component_v_icon, {
              icon: "close",
              width: 11,
              height: 11
            })
          ], 512)
        ]),
        _createVNode(_component_product_picker_search, {
          ref: "searchComponentRef",
          class: _normalizeClass($data.isSearchOpen ? 'grid-rows-1' : 'grid-rows-0'),
          onIsSubmitted: $options.setSearchTerm
        }, null, 8, ["class", "onIsSubmitted"]),
        _createVNode(_component_product_picker_filter, {
          class: _normalizeClass($data.isFilterOpen ? 'grid-rows-1' : 'grid-rows-0'),
          "is-open": $data.isFilterOpen,
          filters: $props.filters,
          onIsSelected: $options.setSelectedFilters
        }, null, 8, ["class", "is-open", "filters", "onIsSelected"])
      ]),
      ($options.quickFiltersArray.length > 0)
        ? (_openBlock(), _createBlock(_component_product_picker_quick_filter, {
            key: 0,
            filters: $options.quickFiltersArray,
            onIsSelected: $options.setQuickFilter
          }, null, 8, ["filters", "onIsSelected"]))
        : _createCommentVNode("", true),
      ($data.filteredCollection.length > 0 || $data.isLoading)
        ? (_openBlock(), _createElementBlock("div", {
            key: $data.filteredCollection,
            class: "grid grid-cols-3 gap-8 text-center"
          }, [
            ($data.isLoading)
              ? (_openBlock(), _createBlock(_component_grid_item_skeleton, {
                  key: 0,
                  rep: $data.filteredCollection.length || 12,
                  "show-price": false,
                  "show-add-to-cart": false
                }, null, 8, ["rep"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  ($data.isEarlyAccessActive && !$options.isCustomerLoggedIn)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("a", {
                            href: $data.theme.routes.storefront_login
                          }, [
                            ($props.earlyAccessBackground)
                              ? (_openBlock(), _createBlock(_component_v_image, {
                                  key: 0,
                                  lazyloaded: "",
                                  source: $props.earlyAccessBackground,
                                  width: 250,
                                  class: "aspect-square h-full w-full object-cover object-center"
                                }, null, 8, ["source"]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_v_icon, {
                                icon: "lock",
                                width: 61,
                                height: 61,
                                color: "#FFF"
                              })
                            ])
                          ], 8, _hoisted_9)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("small", _hoisted_12, _toDisplayString($props.earlyAccessSubtitle), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.filteredCollection, (product, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: product,
                      class: _normalizeClass(["break-words", [
              !product.available && 'pointer-events-none',
              i === $data.activeFilter && $data.skeletonClass,
            ]])
                    }, [
                      _createElementVNode("button", {
                        class: "group",
                        onClick: $event => ($options.selectProduct(product, i))
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_v_image, {
                            lazyloaded: "",
                            source: product.featured_image,
                            width: 250,
                            class: _normalizeClass(["h-full w-full object-cover object-center", !product.available && 'brightness-90'])
                          }, null, 8, ["source", "class"]),
                          ($data.isEarlyAccessActive && $options.isCustomerLoggedIn)
                            ? (_openBlock(), _createBlock(_component_grid_item_tags, {
                                key: 0,
                                class: "px-2 text-[0.5625rem]",
                                product: {
                    tags: product.tags.filter((tag) => tag.toLowerCase() === 'early-access'),
                  },
                                "early-access-enabled": true
                              }, null, 8, ["product"]))
                            : _createCommentVNode("", true),
                          (!product.available)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString($data.locale.sold_out), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("small", {
                            class: "text-[0.6875rem] tracking-wide",
                            style: _normalizeStyle(`color: ${
                    product.deliverable_at ? $data.unavailableProductColor : $data.availableProductColor
                  }`)
                          }, [
                            (product.deliverable_at)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString($data.locale.deliverable_at) + " " + _toDisplayString($options.formatDeliveryDate(product.deliverable_at)), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString($data.locale.available_now), 1)
                                ], 64))
                          ], 4),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(product.title), 1)
                        ])
                      ], 8, _hoisted_13),
                      ($props.isQuickViewEnabled)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "group flex w-full items-center justify-center rounded-full bg-black-150 py-4",
                            onClick: $event => ($options.openQuickView(product))
                          }, [
                            _createVNode(_component_v_icon, {
                              icon: "magnifier",
                              class: "mr-4",
                              width: 12,
                              height: 12
                            }),
                            _createElementVNode("span", _hoisted_19, _toDisplayString($data.locale.quick_view_label), 1)
                          ], 8, _hoisted_18))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ], 64))
          ]))
        : (!$data.filteredCollection.length && !$data.isLoading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString($data.locale.no_results), 1))
          : _createCommentVNode("", true)
    ], 2),
    ($props.isQuickViewEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("button", {
              type: "button",
              class: "h-22",
              onClick: _cache[2] || (_cache[2] = (...args) => ($options.closeQuickView && $options.closeQuickView(...args)))
            }, [
              _createVNode(_component_v_icon, {
                icon: "back-button",
                width: 15,
                height: 14
              })
            ]),
            _createElementVNode("span", _hoisted_23, _toDisplayString($data.locale.quick_view_label), 1)
          ]),
          ($data.quickViewProduct)
            ? (_openBlock(), _createBlock(_component_product_picker_quick_view, {
                key: 0,
                product: $data.quickViewProduct,
                "show-star-rating": $props.showStarRating,
                onIsClicked: _cache[3] || (_cache[3] = $event => ($options.selectProduct($data.quickViewProduct, $data.productsIndex)))
              }, null, 8, ["product", "show-star-rating"]))
            : _createCommentVNode("", true)
        ], 512))
      : _createCommentVNode("", true)
  ]))
}